module.exports = __webpack_public_path__ + "static/media/Venus.fd44dd3c.png";